import { css, cva } from "@stubhub/broadway-foundation/css";

// spacing(n) = n * 4px  (core UI convention)
// spacing(6)=24px, spacing(8)=32px, spacing(10)=40px, spacing(12)=48px

export const bodyWrapperStyle = css({
  width: "full",
  height: "full",
  paddingBlockStart: "primitives.300",
  backgroundColor: "bg",
  // Phone: card-style rounding + elevation shadow, pulled up over the hero image
  // so the rounded corners are visible against the dark hero background.
  borderStartStartRadius: "primitives.300",
  borderStartEndRadius: "primitives.300",
  boxShadow: "[0px -2px 8px 1px rgba(0,0,0,0.08)]",
  marginBlockStart: "-primitives.300",
  tablet: {
    borderStartStartRadius: "primitives.0",
    borderStartEndRadius: "primitives.0",
    boxShadow: "[none]",
    marginBlockStart: "primitives.0",
  },
});

export const twoColumnLayout = cva({
  base: {
    display: "flex",
    flexDirection: "column",
    rowGap: "primitives.300",
    columnGap: "primitives.300",
    desktop: {
      flexDirection: "row",
      alignItems: "flex-start",
      rowGap: "primitives.500",
      columnGap: "primitives.500",
    },
  },
  variants: {
    trendingContent: {
      present: { marginBlockStart: "primitives.100" },
      absent: { marginBlockStart: "primitives.0" },
    },
  },
  defaultVariants: {
    trendingContent: "absent",
  },
});

export const mainColumnStyle = css({
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: "primitives.0",
  minWidth: "primitives.0",
});

export const rightPanelStyle = css({
  display: "none",
  desktop: {
    display: "flex",
    flexDirection: "column",
    rowGap: "primitives.400",
    columnGap: "primitives.400",
    width: "[400px]",
    flexShrink: 0,
    position: "sticky",
    insetBlockStart: "primitives.200",
  },
});

export const verticalMarginRowStyle = css({
  display: "flex",
  justifyContent: "center",
  width: "full",
  marginBlockStart: "primitives.400",
  marginBlockEnd: "primitives.600",
});
